<template>
  <tr :class="[{'active': active}]">
    <td>
      
      <v-row class="align-center" style="min-height: 30px;">
        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              small
              color="grey"
              v-on="on"
            >
              <v-icon small>mdi-android-debug-bridge</v-icon>
            </v-btn>
          </template>
          <v-card outlined class="elevation-0">
            <v-layout class="backgroundCard pa-2 caption">
              JSON
            </v-layout>
            <div class="c-hr"></div>
            <div class="pa-3">
              <span class="caption">
                {{ item }}
              </span>
            </div>
          </v-card>
        </v-menu>

        <v-icon class="drag-handle" color="">
          menu
        </v-icon>

        &nbsp;

        <!--
        <v-icon v-if="item.editable" small color="textSecondary">
          mdi-pencil
        </v-icon>
        -->
        
        <v-icon v-if="!item.editable" small color="textSecondary">
          mdi-lock
        </v-icon>

        &nbsp;

        <span :class="{'color1--text': item.editable}">
          {{ item.name }}
        </span>

        <v-spacer></v-spacer>

        <!-- HOVER -->
        <template v-if="hover">
          <v-tooltip bottom open-delay="200">
            <template v-if="item.editable" v-slot:activator="{ on }">
              <v-btn
              v-on="on"
              icon
              small
              @click.stop="deleteRow"
              class=""
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>

      </v-row>

    </td>
  </tr>
</template>

<script>

export default {
  props: {
    item: null,
    active: null,
    currentSelection: null,
    hover: null
  },
  data () {
    return {
      
    }
  },
  methods: {
    deleteRow () {
      this.$emit('onDelete', this.item)
    }
  }
}
</script>